import { useState } from "react";
import { API } from "@/lib/api";
import { toast } from "sonner";
import { Link } from "react-router-dom";

export default function AdminImportCsv() {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [busy, setBusy] = useState(false);

  const call = async (endpoint) => {
    if (!file) { toast.error("Pilih file CSV dulu"); return null; }
    setBusy(true);
    const fd = new FormData(); fd.append("file", file);
    const token = localStorage.getItem("admin_token");
    try {
      const r = await fetch(`${API}/products/import/${endpoint}`, { method: "POST", body: fd, headers: { Authorization: `Bearer ${token}` } });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(typeof d.detail === "string" ? d.detail : JSON.stringify(d.detail || d));
      return d;
    } catch (e) { toast.error(e.message); return null; }
    finally { setBusy(false); }
  };

  const doPreview = async () => { const d = await call("preview"); if (d) setPreview(d); };
  const doConfirm = async () => {
    if (!preview) return;
    if (preview.error_count > 0) return toast.error("Perbaiki error dulu");
    const d = await call("confirm");
    if (d) { toast.success(`${d.created} produk berhasil dibuat`); setPreview(null); setFile(null); }
  };

  const downloadTemplate = async () => {
    const token = localStorage.getItem("admin_token");
    const r = await fetch(`${API}/products/import/template`, { headers: { Authorization: `Bearer ${token}` } });
    const blob = await r.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href = url; a.download = "products_template.csv"; a.click();
  };

  return (
    <div>
      <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
        <h1 className="display text-4xl md:text-6xl">IMPORT CSV</h1>
        <div className="flex gap-2">
          <button data-testid="download-template" onClick={downloadTemplate} className="border border-white px-6 py-3 text-xs tracking-widest">DOWNLOAD TEMPLATE</button>
          <Link to="/admin/products" className="border border-[color:var(--border)] text-neutral-400 px-6 py-3 text-xs tracking-widest">← BACK</Link>
        </div>
      </div>

      <div className="border border-[color:var(--border)] p-6 space-y-4">
        <p className="text-neutral-400 text-sm">Upload file CSV berisi produk baru. Kolom: article_code, name, category, description, price, sale_price, colors (pisahkan dengan | atau ,), sizes, status, production_method, production_type, featured, new_drop, coming_soon, release_date. Kategori harus sudah ada. Article Code duplikat akan ditolak.</p>
        <input data-testid="csv-file" type="file" accept=".csv" onChange={(e) => { setFile(e.target.files?.[0] || null); setPreview(null); }} className="text-sm" />
        <div className="flex gap-2">
          <button data-testid="csv-preview-btn" onClick={doPreview} disabled={busy || !file} className="bg-white text-black px-6 py-3 text-xs tracking-widest disabled:opacity-60">PREVIEW</button>
          <button data-testid="csv-confirm-btn" onClick={doConfirm} disabled={busy || !preview || preview.error_count > 0} className="border border-white px-6 py-3 text-xs tracking-widest disabled:opacity-40">IMPORT SEKARANG</button>
        </div>
      </div>

      {preview && (
        <div className="mt-6 border border-[color:var(--border)]">
          <div className="p-4 border-b border-[color:var(--border)] flex flex-wrap gap-3 text-sm">
            <span data-testid="csv-total">TOTAL: <strong>{preview.total}</strong></span>
            <span data-testid="csv-valid" className="text-emerald-400">VALID: <strong>{preview.valid_count}</strong></span>
            <span data-testid="csv-errors" className="text-[color:var(--accent)]">ERROR: <strong>{preview.error_count}</strong></span>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full text-xs min-w-[900px]">
              <thead className="text-[10px] tracking-widest text-neutral-500">
                <tr className="border-b border-[color:var(--border)]">
                  <th className="p-2 text-left">LINE</th><th className="p-2 text-left">CODE</th><th className="p-2 text-left">NAME</th>
                  <th className="p-2 text-left">CATEGORY</th><th className="p-2 text-left">PRICE</th>
                  <th className="p-2 text-left">STATUS</th><th className="p-2 text-left">ERRORS</th>
                </tr>
              </thead>
              <tbody>
                {preview.rows.map((r, i) => (
                  <tr key={i} className={`border-b border-[color:var(--border)] ${r.valid ? "" : "bg-red-950/30"}`}>
                    <td className="p-2 mono">{r.line}</td>
                    <td className="p-2 mono">{r.article_code}</td>
                    <td className="p-2">{r.name}</td>
                    <td className="p-2">{r.category}</td>
                    <td className="p-2 tabular-nums">{r.price}</td>
                    <td className="p-2">{r.status}</td>
                    <td className="p-2 text-[color:var(--accent)]">{(r.errors || []).join("; ")}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
